import { Badge } from "@/components/ui/badge";

const STYLES = {
  super_admin: "bg-brand-navy text-white border-transparent",
  admin_manager: "bg-primary text-white border-transparent",
  travel_trainer: "bg-ukgreen text-white border-transparent",
};

const LABELS = {
  super_admin: "Manager",
  admin_manager: "Co-ordinator",
  travel_trainer: "Travel Trainer",
};

export default function RoleBadge({ role, testid }) {
  return (
    <Badge data-testid={testid} className={`${STYLES[role] || ""} text-xs font-semibold tracking-wide`}>
      {LABELS[role] || role}
    </Badge>
  );
}
